import type { IWarehouseRepository } from '../../domain/interfaces';
import type { WarehouseResponseDTO } from '../dtos/warehouse/WarehouseResponseDTO';

export type { WarehouseResponseDTO };

export interface FindWarehousesUseCase {
  execute(activeOnly?: boolean): Promise<WarehouseResponseDTO[]>;
}

export default class FindWarehousesUseCaseImpl implements FindWarehousesUseCase {
  constructor(
    private readonly warehouseRepository: IWarehouseRepository
  ) {}

  async execute(activeOnly = true): Promise<WarehouseResponseDTO[]> {
    try {
      const warehouses = activeOnly
        ? await this.warehouseRepository.findActive()
        : await this.warehouseRepository.findAll();

      return warehouses.map(w => ({
        id: w._id,
        name: w.name,
        status: w.status,
        createdAt: w.createdAt,
        updatedAt: w.updatedAt,
      }));
    } catch (error) {
      throw new Error(`Failed to find warehouses: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}
